import { FormattedMessage } from 'react-intl';
import DoNotDisturbOnOutlined from '@mui/icons-material/DoNotDisturbOnOutlined';
import LogoutOutlined from '@mui/icons-material/LogoutOutlined';
import LockPersonOutlined from '@mui/icons-material/LockPersonOutlined';

import { AppRoutePath } from '@ocx-app/pages/AppRoutePath';
import { List, ListHeader, ListItemButton, ListItemNavLink, ListItemStartIcon, ListItemText, Paper } from '@ocx/ui';
import { openUrlInWindow } from '@ocx/utils-device';
import { logInDev } from '@ocx/utils';
import { useRudderStack } from '@ocx-app/lib/rudderStack/useRudderStack';

import { profileMessages as messages } from '../profile.messages';

export type AccountActionsListProps = {
  isDeleteAccountEnabled: boolean;
  personalDataShareOptOut: { enabled: false } | { enabled: true; optOutUrl: string };
  onLogoutClick: () => void;
};

export const AccountActionsList = (props: AccountActionsListProps) => {
  const { isDeleteAccountEnabled, personalDataShareOptOut, onLogoutClick } = props;
  const { triggerEvent } = useRudderStack();

  return (
    <Paper sx={{ overflow: 'hidden', px: 0, pb: 0 }}>
      <ListHeader>
        <FormattedMessage {...messages['profile:accountSection:title']} />
      </ListHeader>

      <List>
        {personalDataShareOptOut.enabled && (
          <ListItemButton
            onClick={() => {
              openUrlInWindow({ url: personalDataShareOptOut.optOutUrl, nativeMode: 'systemBrowser' }).catch(logInDev);
              triggerEvent('personal_data_share_opt_out_link_clicked');
            }}>
            <ListItemStartIcon>
              <LockPersonOutlined />
            </ListItemStartIcon>
            <ListItemText>
              <FormattedMessage {...messages['profile:accountActions:personalDataShareOptOut']} />
            </ListItemText>
          </ListItemButton>
        )}
        {isDeleteAccountEnabled && (
          <ListItemNavLink to={AppRoutePath.DeleteAccount}>
            <ListItemStartIcon>
              <DoNotDisturbOnOutlined />
            </ListItemStartIcon>
            <ListItemText>
              <FormattedMessage {...messages['profile:accountActions:deleteAccountButtonTitle']} />
            </ListItemText>
          </ListItemNavLink>
        )}
        <ListItemButton onClick={onLogoutClick}>
          <ListItemStartIcon>
            <LogoutOutlined />
          </ListItemStartIcon>
          <ListItemText>
            <FormattedMessage {...messages['profile:accountActions:signOutButtonTitle']} />
          </ListItemText>
        </ListItemButton>
      </List>
    </Paper>
  );
};
